import * as React from "react";
import { SVGProps } from "react";

const Lamden = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2499" {...props}>
    <path fill="#a02870" d="M262.86 959.74 0 1222.55h525.68Z" />
    <path fill="#80286c" d="M525.61 1277.45H.09l262.75 262.79 262.77-262.79Z" />
    <path fill="#c42c79" d="M882.15 920.93 619.31 658.11v525.61Z" />
    <path fill="#a02870" d="M564.44 1183.72V658.11L301.62 920.93Z" />
    <path fill="#c42c79" d="m921 882.1 262.8-262.77H658.14Z" />
    <path fill="#fff" d="M630.69 591.89v-.07Z" />
    <path fill="#e4327f" d="M921 301.62 658.11 564.46h525.66Z" />
    <path fill="#0a8b4b" d="M1540.24 262.82 1277.45 0v525.61Z" />
    <path fill="#e4327f" d="M1222.55 525.63V0L959.74 262.82Z" />
    <path fill="#632a69" d="m882.15 1579-262.84-262.77v525.61Z" />
    <path fill="#80286c" d="m301.65 1579 262.81 262.79v-525.56Z" />
    <path fill="#167b55" d="m1579.05 882.1 262.81-262.77h-525.61Z" />
    <path fill="#0a8b4b" d="M1316.23 564.44h525.63l-262.81-262.82Z" />
    <path
      fill="#402863"
      d="M1183.79 1935.49H658.11l262.82 262.84 262.86-262.84Z"
    />
    <path fill="#632a69" d="m921 1617.85-262.84 262.77h525.56Z" />
    <path fill="#fff" d="M1908.07 1211.15Z" />
    <path fill="#21695e" d="m2198.35 920.93-262.81-262.79v525.56Z" />
    <path fill="#167b55" d="m1617.85 920.93 262.84 262.82V658.11Z" />
    <path fill="#402863" d="m959.76 2237.14 262.79 262.79v-525.61Z" />
    <path
      fill="#223160"
      d="M1277.45 1974.34v525.57l262.81-262.77Zm301.6 224 262.84-262.84h-525.68Z"
    />
    <path fill="#1e4561" d="m1579.05 1617.85-262.77 262.77h525.53Z" />
    <path fill="#245661" d="M1935.56 1316.23v525.58L2198.35 1579Z" />
    <path fill="#1e4561" d="m1617.85 1579 262.84 262.82v-525.61Z" />
    <path fill="#245661" d="M2237.16 1540.24 2500 1277.42h-525.63Z" />
    <path fill="#21695e" d="m2237.16 959.74-262.86 262.81H2500Z" />
  </svg>
);

export default Lamden;
